import * as yup from 'yup';

export const schemaCrmMessage = yup.object().shape({
  client_id: yup
    .string()
    .required('Selecione um cliente para enviar a mensagem'),
  message_type: yup
    .string()
    .required('Tipo de mensagem é obrigatório')
    .oneOf(['TEXT', 'TEMPLATE'], 'Tipo de mensagem inválido'),
  template_id: yup.string().when('message_type', {
    is: 'TEMPLATE',
    then: (schema) =>
      schema.required('Selecione um template para enviar'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  content: yup.string().when('message_type', {
    is: 'TEXT',
    then: (schema) =>
      schema
        .required('Conteúdo da mensagem é obrigatório')
        .min(1, 'Conteúdo da mensagem não pode ser vazio')
        .max(4096, 'Mensagem deve ter no máximo 4096 caracteres'),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
});
